export class MinimalProvider {
  id: number;
  npi: string;
  status: string;
  fullName: string;
  specialties: string[];
  recommendedReferralSpecialty: string;
}
